module.exports = __webpack_public_path__ + "static/org_venture_esg-8315e17ceeb9ea08553d528bf59f9e35.png";